module.exports = __webpack_public_path__ + "static/media/simonSound2.c3c86e71.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/simonSound2.mp3
// module id = 191
// module chunks = 0